import React from 'react';

// Written version of a video training: intro, numbered steps, tips. Mobile friendly (no fixed widths).
export default function WrittenTraining({ training }) {
  if (!training) return null;
  const { intro, steps = [], tips = [] } = training;
  return (
    <div data-testid="written-training" style={{ marginBottom: 24 }}>
      {intro && <p style={{ fontSize: 17, lineHeight: 1.65, color: '#1a1a1a', margin: '0 0 16px' }}>{intro}</p>}
      {steps.length > 0 && (
        <ol style={{ paddingLeft: 22, margin: '0 0 18px' }}>
          {steps.map((s) => <li key={s} style={{ fontSize: 16, lineHeight: 1.6, marginBottom: 10, color: '#1a1a1a', overflowWrap: 'anywhere' }}>{s}</li>)}
        </ol>
      )}
      {tips.length > 0 && (
        <div style={{ background: '#fbf7ee', border: '1px solid #e5d6b0', borderRadius: 8, padding: '12px 16px' }}>
          <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: '0.5px', textTransform: 'uppercase', color: '#8C6D1F', marginBottom: 6 }}>Tips</div>
          <ul style={{ paddingLeft: 20, margin: 0 }}>
            {tips.map((t) => <li key={t} style={{ fontSize: 15, lineHeight: 1.55, marginBottom: 6, color: '#1a1a1a' }}>{t}</li>)}
          </ul>
        </div>
      )}
    </div>
  );
}
